import { render } from "./createMini.vue?vue&type=template&id=37fa2e1a&scoped=true"
import script from "./createMini.vue?vue&type=script&lang=js"
export * from "./createMini.vue?vue&type=script&lang=js"

import "./createMini.vue?vue&type=style&index=0&id=37fa2e1a&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37fa2e1a"]])

export default __exports__